import { forwardRef } from 'react';
import { LinkProps, useHref, useLinkClickHandler } from 'react-router-dom';

import { Button, ButtonProps } from '../Button';

type ButtonLinkProps = LinkProps & ButtonProps;

const Presentation = ({ replace = false, state, to, ...rest }: ButtonLinkProps, ref) => {
  const href = useHref(to);
  const handleClick = useLinkClickHandler<HTMLButtonElement>(to, {
    replace,
    state,
  });

  return <Button {...rest} href={href} onClick={(event) => handleClick(event)} ref={ref} />;
};

export const ButtonLink = forwardRef(Presentation);
